<div class="header">
  <div class="title">Share Folder/File</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<div class="sharing-div">
  <div class="flex">
    <contact-sharing [account]="account" (onUpdateTags)="updateTags($event)"></contact-sharing>
  </div>
  <hr class="mt-4 mb-4" />
  <div class="flex flex-col mt-4">
    <mat-form-field class="treo-mat-textarea treo-mat-no-subscript w-full">
      <mat-label>Message (optional)</mat-label>
      <textarea
        class="leading-normal my-2"
        [(ngModel)]="message"
        matInput
        cdkTextareaAutosize
        placeholder="Write an optional message to be sent to selected email addresses."
      ></textarea>
    </mat-form-field>
  </div>
  <hr class="mt-4 mb-4" />
  <!-- Body -->

  <div class="actions">
    <div class="formatting">
      <div class="flex flex-col">
        <button mat-menu-item (click)="generateShareableLink()" type="button">
          <mat-icon [svgIcon]="'link'" class="mr-0"></mat-icon>
          Generate Shareable Link
        </button>
        <span *ngIf="shareLink">
          <mat-icon
            class="treo-vertical-navigation-item-icon icon-size-14 mr-1"
            [svgIcon]="'file_copy'"
            (click)="copyLinkToClipboard()"
          ></mat-icon
          ><input
            type="text"
            value="{{ publicShareUrl }}"
            class="form-control"
            style="font-size: 11px; width: 300px"
            #shareUrl
            (click)="copyLinkToClipboard()"
          />
        </span>
      </div>
    </div>
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>
      <!-- Send -->
      <button class="send-button" mat-flat-button type="submit" [color]="'primary'" (click)="share()">
        <span>Share With Selected Contacts</span>
      </button>
    </div>
  </div>
</div>
